var map = {
	"./analysis.svg": "ttpT",
	"./data-Construction.svg": "infr",
	"./data-Environment.svg": "0ied",
	"./data-Equipment.svg": "hULm",
	"./data-Geology.svg": "V0Hz",
	"./data-Monitoring.svg": "UVHb",
	"./data-Structure.svg": "vabn",
	"./model.svg": "kd5w"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 112